<template>
    <div class="roma-list-activities" v-if="groupActivities.length">
        <!-- botonera -->
        <!-- <v-row class="mb-5">
          <v-col md="3" class="btn-rocket">
              <v-btn
                large
                rounded
                color="accent"
                class="text-center text-capitalize roma-btn"
                @click="redirectToFirstResourceActivity(groupActivities[0].activityTOS[0])"
              >
                <span>Empezar</span>
                <v-icon class="ml-2" >roma-icon-rocket</v-icon>
              </v-btn>
          </v-col>
        </v-row> -->
        <template v-if="groupActivities.length">
            <v-row class="">
                <v-col
                cols="12"
                v-for="(activity, index) in groupActivities"
                :key="index"
                >
                <v-card class="pr-5 pt-4 pb-4 pl-6 title-card">
                    <img v-if="activity.name == 'Aprendiendo'" src="../../assets/icons/reading-book.svg"> 
                    <img v-if="activity.name == 'Ejercitándome'" src="../../assets/icons/lamp.svg"> 
                    <img v-if="activity.name == 'Evaluando'" src="../../assets/icons/vote.svg"> 
                    
                    
                    <span class="activity-name">{{ activity.name }}</span>
                </v-card>
                <v-col cols="12">
                    <v-list color="transparent"
                        v-for="(item,i) in activity.activityTOS"
                        :key="i"
                        class="mt-0 mb-0 pt-0 pb-0"
                    >
                    
                        <v-list-item class="mt-0 mb-0"
                        @click="redirectToFirstResourceActivity(item)">
                          <v-list-item-icon class="mr-2">
                            <v-icon
                              color="light-blue">
                              mdi-text-box-outline
                              </v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                              <v-list-item-title v-text="item.title" class="list-item-title light-blue--text">
                              </v-list-item-title>
                          </v-list-item-content>
                                <!-- {{ item.code }} -->

                        </v-list-item>

                        
                    </v-list>
                </v-col>
                </v-col>
            </v-row>
        </template>


            
            

        <!-- <ListActivitiesPreview /> -->

    </div>
    <v-row class="mtc-5" v-else>
        <v-col
            class="text-center no-activities"
            cols="12"
        >
            <img
                src="../../assets/images/Ilustracion No tiene actividades.svg"
                alt
                class="no-activities__img"
            />
        </v-col>
        <v-col cols="12" class="text-center">
            <h3>Clase sin actividades registradas</h3>
        </v-col>
    </v-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
      return {
          activities: {
              aprendiendo: [
                  {
                      title: "Mira las instruciones",
                      status: "",
                      typeResource: "text",
                      code: "Código de actividad",
                      icon: "",
                      date: "18/5/2020"
                  },
                  {
                      title: "¿Qué es el cuento?",
                      status: "",
                      typeResource: "video",
                      code: "Código de actividad",
                      icon: "",
                      date: "18/5/2020"
                  },
                  {
                      title: "Guia el cuento y la compresión lectora",
                      status: "",
                      typeResource: "pdf",
                      code: "Código de actividad",
                      icon: "",
                      date: "18/5/2020"
                  }
              ],
              ejercitandome: [
                  {
                      title: "Mira las instruciones",
                      status: "",
                      typeResource: "text",
                      code: "Código de actividad",
                      icon: "",
                      date: "18/5/2020"
                  },
                  {
                      title: "¿Qué es el cuento?",
                      status: "",
                      typeResource: "video",
                      code: "Código de actividad",
                      icon: "",
                      date: "18/5/2020"
                  },
                  {
                      title: "Guia el cuento y la compresión lectora",
                      status: "",
                      typeResource: "pdf",
                      code: "Código de actividad",
                      icon: "",
                      date: "18/5/2020"
                  }
              ],
              evaluando: [
                  {
                      title: "Mira las instruciones",
                      status: "",
                      typeResource: "text",
                      code: "Código de actividad",
                      icon: "",
                      date: "18/5/2020"
                  },
                  {
                      title: "¿Qué es el cuento?",
                      status: "",
                      typeResource: "video",
                      code: "Código de actividad",
                      icon: "",
                      date: "18/5/2020"
                  },
                  {
                      title: "Guia el cuento y la compresión lectora",
                      status: "Tarea Enviada",
                      typeResource: "pdf",
                      code: "Código de actividad",
                      icon: "",
                      date: "18/5/2020"
                  }
              ]
          }
      };
  },
  
  computed: {
    ...mapGetters({
      getActivitiesByGroup: "getActivitiesByGroup",
      getCurrentResources: "getCurrentResources",
    }),

    groupActivities() {
      return this.getActivitiesByGroup.length ? this.getActivitiesByGroup : [];
    }
  },

  async mounted() {
    this.actionSetResourcePaginationIndex(0);
  },

  methods: {
    ...mapActions({
      actionGetLesson: "actionGetLesson",
      actionSetCurrentActivity: "actionSetCurrentActivity",
      actionSetCurrentResource: "actionSetCurrentResource",
      getActivitiesByLessonId: "getActivitiesByLessonId",
      actionSetResourcePaginationIndex: "actionSetResourcePaginationIndex",
      actionResetCurrentResources: "actionResetCurrentResources",
    }),

    async searchFirstResourceIndexForActivity(activity) {
      const index = await this.getCurrentResources.findIndex((resource) => resource.activity.activityLessonId === activity.activityLessonId);
      console.log(index);
      this.actionSetResourcePaginationIndex(index);
      this.redirectToResource(this.getCurrentResources[index]);
    },

    redirectToFirstResourceActivity(activity) {
      console.info("ACTIVIDAD", activity);
      this.searchFirstResourceIndexForActivity(activity);
    },

    redirectToResource(resource) {

      // Guardando recurso actual en vuex
      this.actionSetCurrentResource(resource);

      this.$router.push({ 
        name: 'ActivityType', 
        params: {
          id: resource.resourcesId,
          type: this.getUrlActivity(resource.resourceType.type)
        }
      })
    },
    setCurrentActivityStore(activity){
      this.actionSetCurrentActivity(activity);
    },
    isReadable(resource) {
      
      let response = false;

      switch (resource.resourceType.name) {
        case "ARCHIVO":
          if(resource.fileName) {
            const nameArray = resource.fileName.split(".");
            const extension = nameArray[nameArray.length - 1];

            // 1 - legibles
            // 2 - descargables
            // 3 - link externo

            switch (extension) {
              case "pdf":
                response = 1;
                break;

              case "png":
                response = 1;
                break;

              case "jpeg":
                response = 1;
                break;
              
              case "jpg":
                response = 1;
                break;

              default:
                response = false
                break;
            }
          }
          break;

        case "VIDEO ENLACE":
          response = 1;
          break;
          
        case "TEXTO ENRIQUECIDO":
          response = 1;
          break;
        
        case "ENLACE EXTERNO":
          response = 1;
          break;

        case "ENLACE EXTERNO EMBEBIDO":
          response = 1;
          break;

        default:
          response = false;
          break;
      }

      return response;
    },
    capitalizeString(string) {
      return string.toLowerCase();
    },
    optionFilter() {
      return [
        {
          label: this.$vuetify.lang.t("Actividad"),
          type: "text",
          cols: 8,
          model: { id: 0, text: this.$vuetify.lang.t("Actividad") },
          query: `activity=`,
          options: "",
        },
        {
          label: this.$vuetify.lang.t("Código"),
          type: "text",
          cols: 4,
          model: { id: 0, text: this.$vuetify.lang.t("Código") },
          query: `activity=`,
          options: "",
        },
      ];
    },
    getIconActivity(type) {
      if (type === "TEXT") {
        return "roma-icon-text";
      } else if (type === "EXTERNAL_LINK") {
        return "mdi-link";
      } else if (type === "FILE") {
        return "roma-icon-pdf";
      } else if (type === "VIDEO_LINK") {
        return "roma-icon-video";
      } else if (type === "EXTERNAL_LINK_EMBEDDED") {
        return "mdi-link";
      } else {
        return "";
      }
    },
  },
};
</script>

<style lang="scss">

.roma-list-activities {
    display: block;
  padding: 5px 0 0 5px;
  .lesson-detail__quill {
    .ql-container.ql-snow.ql-disabled {
      border: none;
    }
    // background-color: #bada55;
    * {
      font-family: "Cabin", sans-serif !important;
      font-weight: normal;
      font-size: 18px;
    }
  }

  .filter-container {
    left: 25%;
    width: 60%;
    top: 12%;
    border-radius: 35px;
  }

  .no-padding {
    padding: 0 !important;
  }

  .row-title {
    font-size: 1.1em;
  }

  .block-content {
    color: map-get($colors, "text");

    .img-circle {
      border-radius: 100%;
    }

    h1 {
      padding: 8px 0;
      color: map-get($colors, "primary");
      font-weight: normal;
    }

    p {
      font-weight: normal;
      line-height: 1.5em;
      font-size: 1em;
    }
  }

  h1 {
    padding: 8px 0;
    color: map-get($colors, "primary");
    font-weight: normal;
  }

  .btn-create {
    text-transform: capitalize;
    font-size: 1.5em;
    padding: 15px 40px !important;
    border-radius: 100px !important;
    height: 70px !important;

    img {
      margin-left: 15px;
    }
  }

  .actions {
    float: right;

    button {
      color: #818181 !important;
      text-transform: capitalize;
      background: transparent !important;
      border: none !important;
      box-shadow: none;
      font-weight: normal;
      font-size: 1.25em !important;
      line-height: 1.5em;
      padding: 0 6px !important;
    }

    button:hover {
      box-shadow: none !important;
      background: transparent !important;
    }

    .active {
      color: #3a8fce !important;
    }
  }

  h2 {
    padding: 15px 0 10% 10px;
    color: map-get($colors, "primary");
    font-weight: normal;
    font-size: 2em !important;
  }

  .card-content-list {
    padding: 20px 2% 10px 6%;
  }

  .card-content-list-comments {
    padding: 10px 2% 10px 6%;
  }

  .card-list-activity {
    padding: 0;
    border-radius: 15px !important;

    span:nth-child(1) {
      padding: 35px 0;
      color: map-get($colors, "text");
    }

    .date-activity {
      color: map-get($colors, "blue") !important;
      text-align: right;
    }

    .title-list-activity {
      padding: 5px 0 10% 10px;
      color: map-get($colors, "blue") !important;
      font-weight: normal;
      font-size: 1.85em !important;
    }
  }

  .transparent {
    background: transparent;
    border: none !important;
    box-shadow: none;
  }

  .icon-create-activity:before {
    content: url("../../assets/icons/create-activity-icon-white.svg");
    width: 32px;
    margin-left: 10px;
  }

  .input-comments {
    i {
      color: map-get($colors, "accent") !important;
    }
  }

  .md-10 {
    width: 90%;
  }

  .md-1 {
    width: 5%;
  }

  .btn-clear {
    padding: 0 5px;

    i {
      color: map-get($colors, "accent") !important;
    }
  }

  .btn-download-source {
    font-size: 18px;
    font-weight: normal;
    text-transform: capitalize;
    color: map-get($colors, "purple");
    line-height: 18px;
    height: 50px;
    box-shadow: 0 6px 15px #00000029;
    i {
      padding-left: 10px;
    }
  }

    .title-card {
        display: flex;  
        align-items: center;
        font-size: 20px;
        text-transform: capitalize;
        /* color: map-get($colors, "text"); */
        .activity-name{
          color: #636363;
        }
        img {
            margin: 0 10px 5px 0;
        }

        .icon-title-aprendiendo:before {
            content: url("../../assets/icons/create-activity-icon.svg");
        }

        .icon-title-ejercitandome:before {
            content: url("../../assets/icons/pencil.svg");
        }

        .icon-title-evaluando:before {
            content: url("../../assets/icons/task.svg");
        }
    }


  .icons-card-list {
    font-size: 20px;
    font-weight: normal;
    i {
      font-size: 20px;
      margin-right: 15px;
    }
    a {
      text-decoration: none;
      color: #4a4a4a;
    }
  }


  .date {
    color: map-get($colors, "blue");
    font-weight: 400;
    font-size: 13px;
  }

  .code {
    color: map-get($colors, "text");
    font-weight: 400;
    font-size: 14px;
  }

  .roma-icon-rocket:before {
    content: url("../../assets/icons/spring-swing-rocket.svg");
  }

  .btn-rocket {
    a {
      text-decoration: none;
    }
  }
}

.list-item-title {
  color:#3a8fce ;
  font-size: 20px !important;
  font-weight: normal;
}

.hover-activity:hover {
  cursor: pointer;
  color:#FF7400;
}

@media (max-width: 599px) {
  .list-item-title {
    font-size: 16px !important;
  }
}
</style>